import React from "react";
import Icon from '@ant-design/icons';
import { ReactComponent as MaleUser } from 'assets/img/man.svg';
import { ReactComponent as FemaleUser } from 'assets/img/women.svg';
import { ReactComponent as PencilImg } from 'assets/icons/pen.svg';
import { ReactComponent as DeleteImg } from 'assets/icons/delete.svg';
import { ReactComponent as EyeImg } from 'assets/icons/eye-icon.svg';
import { ReactComponent as DashboardImg } from 'assets/icons/dashboard-icon.svg';
import { ReactComponent as DotImg } from 'assets/icons/dot-svgrepo-com.svg';
import { ReactComponent as InterviewImg } from 'assets/icons/personal-icons/inteview.svg';
import { ReactComponent as DocumentsImg } from 'assets/icons/personal-icons/document.svg';
import { ReactComponent as QpImg } from 'assets/icons/ques-paper.svg';
import { ReactComponent as CertificateImg } from 'assets/icons/personal-icons/certificate.svg';
import { ReactComponent as ActiveCandidImg } from 'assets/icons/personal-icons/active-applicant.svg';
import { ReactComponent as PendingCandidImg } from 'assets/icons/personal-icons/pending-applicant.svg';
import { ReactComponent as SendMailImg } from 'assets/icons/send-mail.svg';
import { ReactComponent as DisableSendMailImg } from 'assets/icons/disable-send-mail.svg';
import { ReactComponent as ExamMenuIcon } from 'assets/icons/exam-menu-icon.svg';
import { ReactComponent as UserImg } from 'assets/icons/multi-user.svg';
import { ReactComponent as BankImg } from 'assets/icons/solving_question.svg';
import { ReactComponent as AdminImg } from 'assets/icons/administrator.svg';
import { ReactComponent as ResultImg } from 'assets/icons/result-icon.svg';
import { ReactComponent as DashImg } from 'assets/icons/dashboard-icon.svg';
import { ReactComponent as CourseImg } from 'assets/icons/personal-icons/course.svg';
import { ReactComponent as SpecImg } from 'assets/icons/personal-icons/department.svg';
import { ReactComponent as SubjImg } from 'assets/icons/personal-icons/book.svg';
import { ReactComponent as GroupImg } from 'assets/icons/personal-icons/group.svg';
import { ReactComponent as DbImage } from 'assets/icons/database.svg';
import { ReactComponent as SyllabusImg } from 'assets/icons/personal-icons/syllabus.svg';

// Define props interface for FemaleIcon component
interface IconProps {
  size: number; // Define size prop as number type
}

const FemaleIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={FemaleUser} style={{ fontSize: size }} />
);
const MaleIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={MaleUser} style={{ fontSize: size }} />
);
const EditIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={PencilImg} style={{ fontSize: size }} />
);
const DeleteIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DeleteImg} style={{ fontSize: size }} />
);
const EyeIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={EyeImg} style={{ fontSize: size }} />
);
const DashboardIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DashboardImg} style={{ fontSize: size }} />
);
const DotIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DotImg} style={{ fontSize: size }} />
);
const InterviewIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={InterviewImg} style={{ fontSize: size }} />
);
const DocumentIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DocumentsImg} style={{ fontSize: size }} />
);
const ResultIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={ResultImg} style={{ fontSize: size }} />
);
const CertificateIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={CertificateImg} style={{ fontSize: size }} />
);
const ActiveCandidateIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={ActiveCandidImg} style={{ fontSize: size }} />
);
const PendingCandidateIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={PendingCandidImg} style={{ fontSize: size }} />
);
const SendMailIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={SendMailImg} style={{ fontSize: size }} />
);
const DisableSendMailIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DisableSendMailImg} style={{ fontSize: size }} />
);
const ExamIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={ExamMenuIcon} style={{ fontSize: size }} />
);
const UsersIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={UserImg} style={{ fontSize: size }} />
);
const BankIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={BankImg} style={{ fontSize: size }} />
);
const AdminIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={AdminImg} style={{ fontSize: size }} />
);
const DashIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DashImg} style={{ fontSize: size }} />
);
const QpIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={QpImg} style={{ fontSize: size }} />
);
const CourseIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={CourseImg} style={{ fontSize: size }} />
);
const DeptIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={SpecImg} style={{ fontSize: size }} />
);
const SubjIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={SubjImg} style={{ fontSize: size }} />
);
const GroupIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={GroupImg} style={{ fontSize: size }} />
);
const DbIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={DbImage} style={{ fontSize: size }} />
);
const SyllabusIcon: React.FC<IconProps> = ({ size }) => (
  <Icon component={SyllabusImg} style={{ fontSize: size }} />
);

export {
  MaleIcon, FemaleIcon, EditIcon, DeleteIcon, EyeIcon, DashboardIcon, DotIcon, InterviewIcon, ExamIcon, UsersIcon, BankIcon, AdminIcon,
  CertificateIcon, DocumentIcon, ResultIcon, ActiveCandidateIcon, PendingCandidateIcon, SendMailIcon, DisableSendMailIcon, DashIcon, QpIcon,
  CourseIcon, DeptIcon, SubjIcon, GroupIcon, DbIcon, SyllabusIcon
};